module.exports = __webpack_public_path__ + "img/益视说明书_08.8c901cf1.png";